var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "partners" } }, [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }),
      _vm._v(" "),
      _c("div", { staticClass: "row justify-content-between" }, [
        _c("div", { staticClass: "col-sm-12 col-md-9 buttons" }, [
          _c("h2", [_vm._v("Nossos Parceiros")]),
          _vm._v(" "),
          _c(
            "a",
            {
              attrs: { target: "_blank", href: "http://www.kaleydos.com.br/" }
            },
            [_c("img", { attrs: { src: _vm.partner1 } })]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              attrs: {
                target: "_blank",
                href: "http://www.institutojatobas.org.br/"
              }
            },
            [_c("img", { attrs: { src: _vm.partner2 } })]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              attrs: {
                target: "_blank",
                href: "http://www.spotpromo.com.br/#SpotInclusao"
              }
            },
            [_c("img", { attrs: { src: _vm.partner4 } })]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-sm-12 col-md-3 buttons" }, [
          _c("h2", [_vm._v("Apoio")]),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "paypal",
              attrs: { target: "_blank", href: "https://paypal.com" }
            },
            [_c("img", { attrs: { src: _vm.partner5 } })]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6413b17a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6413b17a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/PartnersSection.vue
// module id = null
// module chunks = 